export enum ReceiptTypeEnum {
  DEPOSIT = "DEPOSIT",
  WITHDRAW = "WITHDRAW",
  EXCHANGE = "EXCHANGE",
  REMITTANCE = "REMITTANCE",
}
